export const attendanceEmployee = {
  title: '個人別生産性管理',
}
